import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { useTranslation } from "@/hooks/useTranslation"
import { OSStep } from "@/molecules/OSStep"
import {
  DeployTab,
  TitleStepDeployTab,
  type CommonDeployTabProps
} from "@/pages/DeploymentsPage/components/molecules/DeployTab"
import { DownloadStep } from "@/pages/DeploymentsPage/components/organisms/DownloadStep"
import { VmDeployCommand } from "@/pages/DeploymentsPage/components/organisms/VmDeployCommand"
import {
  PACKAGE_SPEC_TYPE,
  VM_WINDOWS_DOCS_SLUG
} from "@/pages/DeploymentsPage/const"
import { getVMFiles } from "@/pages/DeploymentsPage/helpers/file"
import { MessageVmTab } from "."

const SELF_HOSTED_VM_PLATFORMS = ["linux_arm64", "linux_amd64"] as const

export const VmTab = (props: CommonDeployTabProps) => {
  const { noError, version } = props
  const { t: tPlatform } = useTranslation("translation", {
    keyPrefix: "integrations.connect.kodemCLI.platform"
  })
  // TODO: change to vm (add support at the server side)
  // EC2 package is the same as VM

  const { items, isWindows, ...rest } = OSStep({
    // The Windows installer takes no KONTIGO setting, so its sensors could not report to a self-hosted Kontigo
    options: isSelfHosted()
      ? SELF_HOSTED_VM_PLATFORMS.map((platform) => ({
          label: tPlatform(platform),
          value: platform
        }))
      : undefined,
    getSteps: ({ isWindows, OSPlatform, t }) => {
      const tKey = isWindows ? "windows" : "vm"

      return [
        {
          title: (
            <DownloadStep
              noError={noError}
              files={getVMFiles({
                version,
                OSPlatform,
                packageSpecType: PACKAGE_SPEC_TYPE.EC2
              })}
              titlePrefix={t("general.download")}
              title={t(`deployments.${tKey}.deploymentStep`)}
            />
          ),
          status: "process"
        },
        {
          title: (
            <TitleStepDeployTab prefix={t("general.deploy")}>
              {`- ${t(`deployments.${tKey}.commandStep`)}`}
            </TitleStepDeployTab>
          ),
          description: <VmDeployCommand isWindows={isWindows} {...props} />,
          status: "process"
        }
      ]
    },
    getMessage: MessageVmTab
  })

  return (
    <DeployTab
      steps={items}
      docsSlug={isWindows ? VM_WINDOWS_DOCS_SLUG : undefined}
      {...rest}
    />
  )
}
